import { AvailableViewSummary } from 'domain/surveyDataManager/contracts/availableViews';
import { ActiveDefectLayer } from 'state/surveyDataManager';

function normalizeSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

export function availableViewMatchesSearch(
  view: AvailableViewSummary,
  query: string,
): boolean {
  const normalized = normalizeSearchQuery(query);
  if (normalized.length === 0) {
    return true;
  }

  const haystack = [
    view.name,
    view.description,
    view.purpose,
    ...view.componentLabels,
  ]
    .join(' ')
    .toLowerCase();

  return haystack.includes(normalized);
}

export function filterAvailableViewsBySearch(
  views: readonly AvailableViewSummary[],
  query: string,
): readonly AvailableViewSummary[] {
  const normalized = normalizeSearchQuery(query);
  if (normalized.length === 0) {
    return views;
  }
  return views.filter((view) => availableViewMatchesSearch(view, normalized));
}

export function filterPersonalLayersBySearch(
  layers: readonly ActiveDefectLayer[],
  query: string,
): readonly ActiveDefectLayer[] {
  const normalized = normalizeSearchQuery(query);
  if (normalized.length === 0) {
    return layers;
  }
  return layers.filter((layer) =>
    layer.displayName.toLowerCase().includes(normalized),
  );
}
